import { getResourceTo } from './utils';

export const getRouteStatusLabel = (routeStatus) => {
  const mappedStatus = {
    NOT_STARTED:
      getResourceTo('Filter.Route.status.notStarted'),
    STARTED:
      getResourceTo('Filter.Route.status.started'),
    DEPARTED_ORIGIN:
      getResourceTo('Filter.Route.status.departedOrigin'),
    ARRIVED_ORIGIN:
      getResourceTo('Filter.Route.status.arrivedOrigin'),
    COMPLETED:
      getResourceTo('Filter.Route.status.completed')
  };

  return mappedStatus[routeStatus] || '';
};

export const getRouteStatusOptions = () => [
  {
    label: getResourceTo('filter.route.status.all'),
    value: ''
  },
  {
    label: getResourceTo('Filter.Route.status.arrivedOrigin'),
    value: 'ARRIVED_ORIGIN'
  },
  {
    label: getResourceTo('Filter.Route.status.completed'),
    value: 'COMPLETED'
  },
  {
    label: getResourceTo('Filter.Route.status.departedOrigin'),
    value: 'DEPARTED_ORIGIN'
  },
  {
    label: getResourceTo('Filter.Route.status.started'),
    value: 'STARTED'
  },
  {
    label: getResourceTo('Filter.Route.status.notStarted'),
    value: 'NOT_STARTED'
  }
];
